import './SMSQuota.scss';
import {useContext, useEffect, useState} from "react";
import {getFormattedGMTPlus2DateAndTime} from "../../../Utils/Date/Date";
import {CompanyReactContext} from "../../../contexts/CompanyContext";
import {I18nReactContext} from "../../../contexts/I18nContext";

/**
 * Component for displaying SMS quota information
 * @returns {JSX.Element} The SMS quota component
 */
export const SMSQuota = () => {
    const {i18n} = useContext(I18nReactContext);
    const [isLoading, setIsLoading] = useState(true)
    const companyContext = useContext(CompanyReactContext);

    useEffect( () => {
        setIsLoading(true)
        companyContext.refreshCompanyQuota()
            .finally(() => {
                setIsLoading(false)
            })
    }, [companyContext]);

    return <div className="SMSQuota">
        {/*<div className="bell-icon">*/}
        {/*    <img src={bellIcon} alt=""/>*/}
        {/*</div>*/}
        <div className="SMSQuota__header">
            <h2>{i18n.translate('settingsPage.SMSQuota.title')}</h2>
        </div>
        <div className="SMSQuota__content">
            <div className="SMSQuota__content__item">
                {isLoading ? '' : <div className="SMSQuota__content__item__title">{i18n.translate('settingsPage.SMSQuota.sent', {
                    context: {
                        sent: companyContext.sentQuota,
                        quota: companyContext.remainingQuota
                    }
                })}</div>}
            </div>
            <div className="SMSQuota__content__item">
                {isLoading || !companyContext.sentQuota ? '' : <div
                    className="SMSQuota__content__item__title">{i18n.translate('settingsPage.SMSQuota.lastSMSWasSentOn', {context: {date:getFormattedGMTPlus2DateAndTime(companyContext.lastSMSDate)}})}</div>}
            </div>
        </div>
    </div>
}